import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { Role } from '../services/model';

export const roleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const expectedRoles = route.data['roles'] as Role[];

  // Prevent infinite loops - if already on unauthorized page, allow access
  if (state.url === '/unauthorized') {
    return of(true);
  }

  return authService.getUserClaims().pipe(
    take(1),
    map((claims) => {
      if (!claims) {
        console.warn('🚫 Role Guard - No claims found, redirecting to unauthorized');
        router.navigate(['/unauthorized']);
        return false;
      }

      const roles = claims['cognito:groups'] || claims.roles || [];
      const userRoles = Array.isArray(roles) ? roles : [roles];

      const hasRole = userRoles.some((role: any) => expectedRoles.includes(role));

      if (!hasRole) {
        console.warn('🚫 Role Guard - User lacks required role. User roles:', userRoles, 'Required:', expectedRoles);
        router.navigate(['/unauthorized']);
        return false;
      }

      console.log('✅ Role Guard - Access granted. User has required role');
      return true;
    })
  );
};
